/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Breadcrumbs, Divider, Link } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { useAppDispatch, type RootState } from "src/redux/store";
import HomeIcon from "@mui/icons-material/Home";
import {
  Ibreadcrumb,
  setBreadcrumbs,
} from "src/redux/features/breadcrumbSlice";
import { useNavigate } from "react-router-dom";

function Breadcrumb() {
  const breadcrumbs: Ibreadcrumb[] = useSelector(
    (state: RootState) => state.breadcrumbs,
  );
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  return (
    <>
      <Breadcrumbs sx={{ marginTop: 2 }}>
        {breadcrumbs.map((breadcrumb, index: number) => (
          <Link
            sx={{
              textDecoration: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              fontWeight: 200,
            }}
            key={breadcrumb.url}
            color="inherit"
            href={index === breadcrumbs.length - 1 ? undefined : breadcrumb.url}
            onClick={() => {
              // Si es el ultimo item del breadcrumb, no hacer nada
              if (index === breadcrumbs.length - 1) return;
              // Navegar a la url del breadcrumb clickeado
              navigate(breadcrumb.url);
              // Setear breadcrumbs, eliminando los que estan despues del breadcrumb clickeado
              dispatch(setBreadcrumbs(breadcrumbs.slice(0, index + 1)));
            }}
          >
            {index === 0 ? (
              <HomeIcon
                sx={{ paddingBottom: 0.5, marginRight: 1, color: "grey.500" }}
              />
            ) : null}
            {breadcrumb.label}
          </Link>
        ))}
      </Breadcrumbs>
      <Divider />
    </>
  );
}

export default Breadcrumb;
